/* eslint-disable no-shadow,no-underscore-dangle */
import { BUSINESS_DETAILS_GET, BUSINESS_ADD } from './action-modulation.type';
import BusinessDetailsService from '../services/businessDetails.service';

export const state = {
  business: null,
};

export const actions = {
  [BUSINESS_DETAILS_GET](context, params) {
    return BusinessDetailsService.getBusinessDetails(params).then(({ data }) => {
      context.commit(BUSINESS_ADD, data);
    }).catch(error => error);
  },
};

export const mutations = {
  [BUSINESS_ADD](state, business) {
    state.business = business;
  },
};

export default {
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/business.module.js